import { useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';
import { API_NOTICE_EVENT } from '../../utils/activeOrganization';

/** Shows read-only / suspended / plan-expired refusals once, however many requests hit them. */
const ApiNotices = () => {
  const { enqueueSnackbar } = useSnackbar();
  const last = useRef<{ message: string; at: number } | null>(null);

  useEffect(() => {
    const onNotice = (e: Event) => {
      const { status, message } = (e as CustomEvent).detail as { status: number; message: string };
      const now = Date.now();
      if (last.current && last.current.message === message && now - last.current.at < 5000) return;
      last.current = { message, at: now };
      enqueueSnackbar(message, { variant: status === 402 ? 'warning' : 'error', preventDuplicate: true });
    };
    window.addEventListener(API_NOTICE_EVENT, onNotice);
    return () => window.removeEventListener(API_NOTICE_EVENT, onNotice);
  }, [enqueueSnackbar]);

  return null;
};

export default ApiNotices;
